import React, { useCallback, useEffect } from "react";
import { Typography } from "antd";
import { useFetchApi } from "../../../../../../hooks/useFetchApi";
import { ChartCard } from "../components/ChartCard";

const { Title } = Typography;

interface DividendsProps {
  selectedStock?: any;
  baseCurrency: string;
}

export const Dividends: React.FC<DividendsProps> = ({
  selectedStock,
  baseCurrency,
}) => {
  const {
    execute: generateDividendsGraph,
    loading: dividendsLoading,
    response: dividendsGraphData,
  } = useFetchApi("/api/dynamic-graph");

  const fetchGraph = useCallback(() => {
    if (!selectedStock) return;

    generateDividendsGraph({
      selectedStocks: [selectedStock],
      filter: "annually",
      baseCurrency,
      selectedMetrics: [
        { name: "DPS Split Adjusted", sortableId: "1-Investor Ratio-2" },
      ],
      period: "5",
    });
  }, [selectedStock, baseCurrency]);

  useEffect(() => {
    fetchGraph();
  }, [selectedStock, baseCurrency]);

  return (
    <div>
      <Title level={5}>Dividends</Title>
      <div className="flex flex-col gap-6">
        <ChartCard
          title=""
          subtitle="Annual trend"
          graphData={dividendsGraphData}
          loading={dividendsLoading}
          baseCurrency={baseCurrency}
          defaultChartType="bar"
          defaultFilter="annually"
          showFilterToggle={false}
        />
      </div>
    </div>
  );
};
